import genericErrorEn from "./locales/en.json";

export const GENERIC_ERROR_NS = "generic-error" as const;

export const GenericErrorTranslations = {
  en: {
    [GENERIC_ERROR_NS]: {
      ...genericErrorEn,
    },
  },
};
